import { Feature } from '../../../../models';

export interface TrueBundlePlan {
  feature: Feature;
  productId: string;
  titleId: string;
  tooltipTitleId: string;
  descriptionId: string;
  priceHelpId: string;
  productLabelIds: string[];
  benefitIds: string[];
}

export const TRUE_BUNDLE_PLAN_OPTIONS: TrueBundlePlan[] = [
  {
    feature: Feature.TRUE_AUTOMATION,
    productId: 'true_automation',
    titleId: 'page.plan.v2.true.automation.title',
    tooltipTitleId: 'page.plan.v2.true.automation.tooltip.title',
    descriptionId: 'page.plan.v2.true.automation.description',
    priceHelpId: 'page.plan.v2.true.automation.price.help',
    productLabelIds: [
      'page.plan.v2.true.product.platform',
      'page.plan.v2.true.product.cloud',
      'page.plan.v2.true.product.studio',
    ],
    benefitIds: [
      'page.plan.v2.true.automation.benefit.studio',
      'page.plan.v2.true.automation.benefit.authoring',
      'page.plan.v2.true.automation.benefit.ai',
      'page.plan.v2.true.automation.benefit.mcp',
      'page.plan.v2.true.automation.benefit.record',
      'page.plan.v2.true.automation.benefit.coverage',
      'page.plan.v2.true.automation.benefit.management',
      'page.plan.v2.true.automation.benefit.viewer',
      'page.plan.v2.true.automation.benefit.parallel',
      'page.plan.v2.true.automation.benefit.live',
    ],
  },
  {
    feature: Feature.TRUE_PLATFORM_ONLY,
    productId: 'true_platform',
    titleId: 'page.plan.v2.true.platform.title',
    tooltipTitleId: 'page.plan.v2.true.platform.tooltip.title',
    descriptionId: 'page.plan.v2.true.platform.description',
    priceHelpId: 'page.plan.v2.true.platform.price.help',
    productLabelIds: [
      'page.plan.v2.true.product.platform',
      'page.plan.v2.true.product.cloud',
    ],
    benefitIds: [
      'page.plan.v2.true.platform.benefit.management',
      'page.plan.v2.true.platform.benefit.ai',
      'page.plan.v2.true.platform.benefit.mcp',
      'page.plan.v2.true.platform.benefit.viewer',
      'page.plan.v2.true.platform.benefit.live',
    ],
  },
];

export const TRUE_BUNDLE_PURCHASE_FEATURES = TRUE_BUNDLE_PLAN_OPTIONS.map(
  plan => plan.feature,
);

/**
 * Katalon Studio Enterprise rendered as a row of the main plan table (after True
 * Automation and True Platform). It shares the row layout with the True bundle plans but
 * its seats/interval state and preview requests stay on the "more testing products" path,
 * so it is not part of TRUE_BUNDLE_PLAN_OPTIONS / TRUE_BUNDLE_PURCHASE_FEATURES.
 */
export const KSE_STUDIO_PLAN_ROW: TrueBundlePlan = {
  feature: Feature.PER_USER_KSE,
  productId: 'kse',
  titleId: 'feature.per_user_kse.product.name',
  tooltipTitleId: 'page.plan.v2.true.studio.tooltip.title',
  descriptionId: 'page.plan.v2.true.testing.studio.description',
  priceHelpId: 'page.plan.v2.true.automation.price.help',
  productLabelIds: [
    'page.plan.v2.true.product.studio',
  ],
  benefitIds: [
    'page.plan.v2.true.studio.benefit.authoring',
    'page.plan.v2.true.studio.benefit.ai',
    'page.plan.v2.true.studio.benefit.record',
    'page.plan.v2.true.studio.benefit.coverage',
  ],
};

export const TRUE_MORE_TESTING_PRODUCT_FEATURES = [
  Feature.PER_USER_KSE,
  Feature.UNLIMITED_ENGINE,
  Feature.TESTCLOUD_SESSION_CROSS_BROWSER,
  Feature.TESTCLOUD_SESSION_MOBILE_APP,
];

export const DEFAULT_TRUE_BUNDLE_FEATURE = Feature.TRUE_AUTOMATION;

export const getTrueBundlePlan = (
  feature?: Feature,
): TrueBundlePlan => TRUE_BUNDLE_PLAN_OPTIONS.find(
  plan => plan.feature === feature,
) ?? TRUE_BUNDLE_PLAN_OPTIONS[0];
